import { render, staticRenderFns } from "./ForwarderList.vue?vue&type=template&id=599b1858"
import script from "./forwarderList.ts?vue&type=script&lang=js&external"
export * from "./forwarderList.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports